<template>
	<div>
		<v-dialog v-model="dialog_transaction_options" no-click-animation scrollable persistent content-class="full-height" transition="dialog-bottom-transition">
	      <!-- <v-card v-if="$parent.displayData || showAll"> -->
        <v-card>
	        <v-card-title noshadow class="dialog_searchbox">
	        	<v-subheader full-width>Add Transaction</v-subheader>
	        </v-card-title>
	        <v-divider></v-divider>
	        <v-card-text grey-back full-height nopadding>

	        	<v-list nopadding margin-bottom-ten subheader v-for="(category, index) in listCategories" :key="index" v-if="category.showGroup && (!groupTypeId || (!category.groupTypeId || (category.groupTypeId == groupTypeId)))">
		          <v-subheader light v-if="category.name">{{category. name}}</v-subheader>
		          <v-divider v-if="category.name"></v-divider>
		          <v-list-tile v-for="(item, itemIndex) in category.items" v-ripple :key="itemIndex" @click="fn_openForm(item.uri)">
		            <v-list-tile-content>
		              <v-list-tile-title v-html="item.title"></v-list-tile-title>
		            </v-list-tile-content>

		            <v-list-tile-action>
		              <v-icon>keyboard_arrow_right</v-icon>
		            </v-list-tile-action>

		          </v-list-tile>
		        </v-list>

	        </v-card-text>
	        <v-divider></v-divider>
	        <v-card-actions>
	        	<v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click.native="dialog_transaction_options=false">close</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['groupTypeId', 'accountId', 'accountName', 'showAll', 'showPartyOptions', 'closeDialog'],
		data(){
			return{
				dialog_transaction_options: false,
				"listCategories":[	
					{
						"name":null, 
						"groupTypeId":null,
						"showGroup":this.showPartyOptions,
						"items":[
							{
								"id":1, 
								"title":"Opening Ledger",
								"uri":"transactions/inventory/openingledger/items",
								"routeName":""
							},
							{
								"id":2, 
								"title":"Set Balance",
								"uri":"transactions/setbalance/items",
								"routeName":""
							}
						]
					},	
					{
						"name":"Sales",
						"groupTypeId":101, 
						"showGroup":true,
						"items":[
							{
								"id":1, 
								"title":"Order",
								"uri":"transactions/sales/order/items",
								"routeName":""
							},
							{
								"id":2, 
								"title":"Delivery Challan",
								"uri":"transactions/sales/deliverychallan/items",
								"routeName":""
							},
							{
								"id":3, 
								"title":"Sale Invoice",
								"uri":"transactions/sales/saleinvoice/items",
								"routeName":""
							},
							{
								"id":4, 
								"title":"Sale Return",
								"uri":"transactions/sales/salereturn/items",
								"routeName":""
							},
							{
								"id":5, 
								"title":"Estimate",
								"uri":"transactions/sales/estimate/items",
								"routeName":""
							},
						]
					},
					{
						"name":"Purchase", 
						"groupTypeId":102,
						"showGroup":true,
						"items":[
							{
								"id":1, 
								"title":"Purchase Order",
								"uri":"transactions/purchase/purchaseorder/items",
								"routeName":""
							},
							{
								"id":2, 
								"title":"Purchase Challan",
								"uri":"transactions/purchase/purchasechallan/items",
								"routeName":""
							},
							{
								"id":3, 
								"title":"Purchase Invoice",
								"uri":"transactions/purchase/purchaseinvoice/items",
								"routeName":""
							},
							{
								"id":4, 
								"title":"Purchase Return",
								"uri":"transactions/purchase/purchasereturn/items",
								"routeName":""
							},
							{
								"id":5, 
								"title":"Expense",
								"uri":"transactions/purchase/expense/items",
								"routeName":""
							},
						]
					},
					{
						"name":"Account Books", 
						"groupTypeId":null,
						"showGroup":true,
						"items":[
							{
								"id":1, 
								"title":"Payment In",
								"uri":"transactions/receipt/items",
								"routeName":""
							},
							{
								"id":2, 
								"title":"Payment Out",
								"uri":"transactions/payment/items",
								"routeName":""
							},
							{
								"id":3, 
								"title":"Journal",
								"uri":"transactions/journal/items",
								"routeName":""
							},
							{
								"id":4, 
								"title":"Cash and Bank",
								"uri":"transactions/contra/items",
								"routeName":""
							},
							// {
							// 	"id":5, 
							// 	"title":"Credit Note",
							// 	"uri":"transactions/creditnote/items",
							// 	"routeName":""
							// },
							// {
							// 	"id":6, 
							// 	"title":"Debit Note",
							// 	"uri":"transactions/debitnote/items",
							// 	"routeName":""
							// },
						]
					}
				]
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_transaction_options = true;
			},
			closeDialogWeb: function () {
				this.dialog_transaction_options = false;
			},
			fn_openForm: function(uri){
				localStorage.setItem("SetDataDrive", 1);
                this.closeDialog ? this.closeDialog() : this.closeDialogWeb();
				if(this.showAll){
					this.$router.push({path:'/'+uri+'/new', query:{tagId:this.guidWeb()}});	
				}
				else{
					this.$router.push({path:'/'+uri+'/new', query:{tagId:this.guidWeb(), id:this.accountId, name:this.accountName, dt:1}});
				}
				// this.$router.push({path:'/'+uri+'/new', query:{tagId:this.guidWeb(), id:this.accountId, name:this.accountName, dt:1}});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_transaction_options.vue